import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { StaticLinkButton } from 'Components/Fields/Buttons';
import { Navigate } from 'react-router-dom';
import './VeteransAdvantageError.css';
import { clearVeteransAdvError } from 'State/Integrations/IntegrationsActions';

const VA_PATH =
  'https://www.veteransadvantage.com/offers/dining-entertainment/fox-news-salutes-you-free-1-year-subscription-fox-nation';

export const VeteransAdvantageError = () => {
  const dispatch = useDispatch();
  const { routes } = useSelector((s) => s.appConfig);
  const { error: vaError } = useSelector((s) => s.integrations.veteransAdv);

  useEffect(() => {
    return () => {
      dispatch(clearVeteransAdvError());
    };
  }, [dispatch]);

  if (!vaError) {
    return <Navigate replace to={routes.welcome} />;
  }

  return (
    <CenterFrameLayout modernLayout>
      <div className="vaErrorMessage">{vaError}</div>
      <StaticLinkButton className="backToVaButton" path={VA_PATH} text="Back to Veterans Advantage" />
    </CenterFrameLayout>
  );
};
